import {DataExplorerState, ExplorerView, RootState} from '@/types';
import { GetterTree, MutationTree, ActionTree, Module } from 'vuex';


type DataExplorerGetter = GetterTree<DataExplorerState, RootState>;

export const initialState = (): DataExplorerState => {
  return {
    initialState,
    lastView: null,
  };
};

export const getters: DataExplorerGetter = {
  lastView: (state) => state.lastView,
};

export const mutations: MutationTree<DataExplorerState> = {
  setLastView(state, newView: ExplorerView) {

    if (newView) {
      state.lastView = { id: newView.id!, organisation_id: newView.organisation_id };
    }
  },
  clearLastView(state) {
    state.lastView = null;
  },
};

export const actions: ActionTree<DataExplorerState, RootState> = {

};


export const explorer: Module<DataExplorerState, RootState> = {
  state: initialState(),
  getters,
  mutations,
  actions,
};
